// Prismjs
// https://prismjs.com/#basic-usage
import Prism from 'prismjs';

// Prism Load Languages
import 'prismjs/components/prism-javascript';
import 'prismjs/components/prism-css';
import 'prismjs/components/prism-python';
import 'prismjs/components/prism-markup';

// FANUC Karel language
import registerKarel from 'prism-fanuc-karel';
registerKarel(Prism); // registers 'fanuc-karel', 'karel', 'kl', 'fanuc-tp', 'tp', 'ls' aliases

// Prism Plugins
import 'prismjs/plugins/line-numbers/prism-line-numbers.js';

// Prism Styles
import 'prism-fanuc-karel/dark';
import 'prismjs/plugins/line-numbers/prism-line-numbers.css';

// Intl Tel Input
// import intlTelInput from 'intl-tel-input';
// import 'intl-tel-input/build/css/intlTelInput.css';

function initPrism() {
    const codeBlocks = document.querySelectorAll(
        'pre > code[class*="language-"], pre > code[class*="lang-"], ' +
        'figure.code-example > pre > code[class*="language-"], figure.code-example > pre > code[class*="lang-"]'
    );

    codeBlocks.forEach((codeBlock) => {
        const pre = codeBlock.parentElement;
        const languageClass = Array.from(codeBlock.classList).find((className) => /^(language|lang)-/.test(className));

        if (!pre) {
            return;
        }

        pre.classList.add('prism-code-block', 'line-numbers');

        if (languageClass) {
            pre.classList.add(languageClass.replace(/^lang-/, 'language-'));
        }
    });

    Prism.highlightAllUnder(document);

    if (Prism.plugins.lineNumbers) {
        requestAnimationFrame(() => {
            document.querySelectorAll('pre.line-numbers').forEach((pre) => {
                Prism.plugins.lineNumbers.resize(pre);
            });
        });
    }

    return codeBlocks.length;
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPrism, { once: true });
} else {
    initPrism();
}
